// This module exposes various getters to manipulate color output
// https://github.com/Qix-/color#getters
import Color from 'color';

export const blue = Color('#2ac2e9');
export const red = Color('#DB3F35');
export const green = Color('#2a9606');
export const white = Color('#ffffff');
export const black = Color('#111');
export const teal = Color('#156777');
export const lightTeal = Color('#CBDDE1');
export const midTeal = Color('#8EAEB2');
export const deepRed = Color('#AA2D2D');
export const charcoal = Color('#231F20');
export const midGray = Color('#909090');
export const lightGray = Color('#b4b4b4');
export const offWhite = Color('#f1f2f2');
export const darkGray = Color('#58585a');
export const authGray = Color('#ecedef');
export const authErrorBackground = Color('#ecc7cf');
export const authErrorText = Color('#ff6a8a');
export const authMessageBackground = Color('#f2f2f2');
export const authMessageText = Color('#1c928e');
export const disabled = Color('#cccccc');

export default {
  blue,
  red,
  green,
  white,
  black,
  teal,
  lightTeal,
  midTeal,
  deepRed,
  charcoal,
  midGray,
  lightGray,
  offWhite,
  darkGray,
  authGray,
  authErrorBackground,
  authErrorText,
  authMessageBackground,
  authMessageText,
  disabled,
};
